import React from 'react';

import { createHashRouter } from 'react-router-dom';
import Layout from '../components/Layout';
import Devices from '../routes/Devices';
import EditDeviceForm from '../routes/EditDeviceForm';
import EditObjectForm from '../routes/EditObjectForm';
import ErrorPage from '../routes/ErrorPage';
import NewDeviceForm from '../routes/NewDeviceForm';
import NewObjectForm from '../routes/NewObjectForm';
import Objects from '../routes/Objects';

const router = createHashRouter([
    {path: '/', element: <Layout />, children: [
      {index: true , element: <Objects /> },
      {path: 'objects/new', element: <NewObjectForm />},
      {path: 'objects/:objectId', element: <EditObjectForm />},
      {path: 'devices', element: <Devices />},
      {path: 'devices/:deviceId', element: <EditDeviceForm />},
      {path: 'devices/new', element: <NewDeviceForm />},
      {path: '*', element: <ErrorPage msg='Page not found' />},
    ]},
  ])

export default router;